import { Checkbox } from '@cian/ui-kit';
import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { InlineFilter } from 'shared/components/InlineFilter';
import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';
import { RangeInput } from 'shared/components/RangeInput';
import { useDebouncedCallback, useFilterChangeCallback } from 'shared/hooks';
import { selectFloorCommercialFilter } from 'shared/selectors/advancedFilters';
import { selectFloorTypes } from 'shared/selectors/jsonQuery';
import { EFloorTypes } from '../../../../../../../packages/api-models/common/json_query';

export const FloorCommercialContainer: FC = () => {
  const {
    label,
    value: { min: valueMin, max: valueMax },
    min,
    max,
    onlyFirstFloor,
    notBasement,
  } = useSelector(selectFloorCommercialFilter);
  const floorTypes = useSelector(selectFloorTypes);

  const onChange = useFilterChangeCallback();

  const handleMinChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setFloorMin', arguments: [value] });
  });

  const handleMaxChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setFloorMax', arguments: [value] });
  });

  const toggleFloorType = useCallback(
    (type: EFloorTypes, checked: boolean) => {
      const current = floorTypes ?? [];
      const next = checked ? [...current.filter(t => t !== type), type] : current.filter(t => t !== type);
      onChange({ action: 'setFloorTypes', arguments: [next.length > 0 ? next : null] });
    },
    [floorTypes, onChange],
  );

  const handleOnlyFirstChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      toggleFloorType(EFloorTypes.OnlyFirstFloor, checked);
    },
    [toggleFloorType],
  );

  const handleNotBasementChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, checked: boolean) => {
      toggleFloorType(EFloorTypes.NotBasement, checked);
    },
    [toggleFloorType],
  );

  return (
    <AdvancedFilterRow label={label}>
      <InlineFilterGroup>
        <InlineFilter width={100}>
          <RangeInput
            min={min}
            max={max}
            valueMin={valueMin}
            valueMax={valueMax}
            disabled={onlyFirstFloor}
            onChangeMin={handleMinChange}
            onChangeMax={handleMaxChange}
          />
        </InlineFilter>

        <InlineFilter>
          <Checkbox label="Только первый" checked={onlyFirstFloor} onChange={handleOnlyFirstChange} />
        </InlineFilter>

        <InlineFilter>
          <Checkbox label="Не цоколь, не подвал" checked={notBasement} onChange={handleNotBasementChange} />
        </InlineFilter>
      </InlineFilterGroup>
    </AdvancedFilterRow>
  );
};
